import React, { useState, useEffect, useLayoutEffect } from "react";
import { useJwt } from "react-jwt";
import { useLocation } from "react-router-dom";

import { authService } from "../services/auth";

// high level component, wraps most of app
// passes auth params to children components
// upon state changes, re-assesses expiration of access token
const Authentication = ({ children }) => {
  const location = useLocation();
  const [accessToken, setAccessToken] = useState(localStorage.getItem("accessToken"));
  // OAuth writes localStorage then navigates before React state catches up; prefer storage so
  // the first render after /auth/callback/ is not treated as logged out (avoids /login/ -> /audit/).
  const storageToken = typeof window !== "undefined" ? localStorage.getItem("accessToken") : null;
  const effectiveToken = storageToken || accessToken;
  const { isExpired } = useJwt(effectiveToken);

  useLayoutEffect(() => {
    setAccessToken(localStorage.getItem("accessToken"));
  }, [location.pathname]);

  useEffect(() => {
    if (effectiveToken && isExpired) {
      authService.refreshToken(
        (newToken) => {
          setAccessToken(newToken);
        },
        () => {
          console.error("couldnt refresh token");
          window.location = `/login/?next=${window.location.pathname}`;
        }
      );
    }
  }, [effectiveToken, isExpired]);

  useEffect(() => {
    if (effectiveToken && !isExpired) {
      authService.fetchUser();
    }
  }, [effectiveToken, isExpired]);

  var authState = {
    authenticated: false,
    accessToken: null,
    refreshToken: null,
    refreshingToken: false,
    currentUser: null,
    location: location,
  };

  if (effectiveToken && !isExpired) {
    let currentUser = null;
    try {
      currentUser = JSON.parse(localStorage.getItem("currentUser") || "null");
    } catch (error) {
      currentUser = null;
    }

    authState = Object.assign(authState, {
      authenticated: true,
      accessToken: effectiveToken,
      refreshToken: localStorage.getItem("refreshToken"),
      currentUser: currentUser,
    });
  } else if (effectiveToken && isExpired) {
    authState = Object.assign(authState, {
      refreshingToken: true,
    });
    return "";
  }

  return <React.Fragment>{children({ ...authState })}</React.Fragment>;
};

export default Authentication;
